import React,{useEffect,useState} from "react";
import { Alert, Stack,AlertTitle, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { alertMessageActions, alertActions, announcementAction, } from '_store';
import { useLocation } from 'react-router-dom';
import Grid from "@mui/material/Grid2";
import { ERR_MSG } from "constants/labels";
const AlertMessage = ({portalID}) => {
        const authUser = useSelector(x => x.auth.value);
        const user = authUser?.Data;
        const userdetails = user?.UserDetails;
  const isMCUserExpired = userdetails?.Status === "Expired"
  const isMCUserPartiallyApproved = userdetails?.Status === "Partially Approved"
  const isMCUserPartiallyVerified = userdetails?.Status === "Partially Verified"
        const location = useLocation();
      const dispatch = useDispatch();
    const [data,setData] = useState([]);
    const [alertMessage,setAlertMessage] = useState(false);
    const [dismissedIds, setDismissedIds] = useState([]);
    const portalid =
      (sessionStorage.getItem("portalID") ??
        sessionStorage.getItem("portalID")) ||
      portalID;
    const Roleid = user?.UserAccess?.filter(user => user.PortalId == portalid);
    const handleClose =(id) => {
      setDismissedIds((prev) => [...prev, id]);
      
    };

  const handleDownload = async (file) => {
      const { Url: fileName, File: localFile } = file;
      try {
          if (fileName) {
              await dispatch(announcementAction.downloadFile(fileName)).unwrap();
          } else if (localFile) {
              const url = URL.createObjectURL(localFile);
              const link = document.createElement("a");
              link.href = url;
              link.download = localFile?.name;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
          } else {
              throw new Error(ERR_MSG["073"]);
          }
      } catch (error) {
          dispatch(
              alertActions.error({
                  message: error.message ? ERR_MSG["073"] : error,
                  header: "Download Failed",
              })
          );
      }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(alertActions.clear());
      try {
        let abc = Roleid[0]?.RoleId;
        if (
          portalid === 98 ||
          portalid === 99 ||
          !abc || portalid === "null" ||
          location.pathname === '/home#'
        ) {
          return;
        }else{
          let  transformed = {
            portalID : portalid,
            roleId :Roleid[0]?.RoleId,
            // Roleid: user?.UserAccess?.filter(user => user.PortalId === portalid);
        }
        const result = await dispatch(alertMessageActions.getAlertMessageDetails(transformed)).unwrap();
        const details = result?.Data;
        setData(details);
        return;
        }

      } catch (error) {
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header: "Download Failed",
          }),
        );
      }
    };
    if(!isMCUserExpired && !isMCUserPartiallyApproved && !isMCUserPartiallyVerified){
      fetchData();
    }
    
  }, [dispatch, portalID,location.pathname]);
    return(
<>
{data && data.map(item =>(
   !dismissedIds.includes(item.ID) ? (
    <Stack className="Stackalert" sx={{ width: '100%' }} spacing={2} style={{display : alertMessage ? 'none' : 'block' }}>
      <Alert style={{width:'100%'}} icon={false} severity="error" onClose={() => handleClose(item.ID)}>
      <Grid container direction="row" spacing={2}>
      <Grid size={{ xs: 6, sm: 6, md: 4}}>
      <AlertTitle className="alertitle">{item.Title}</AlertTitle>
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 4}}>
      <Typography className="alertdata">{item.Data}</Typography>
      </Grid>      
      {item?.FileData && (
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>              
              <Button variant="contained" onClick={() => handleDownload(item.FileData)}>Download File</Button>
          </Grid>
      )}
      </Grid>
      
      </Alert>
      </Stack>
   ):null
))
}
</>
    )
}

export default AlertMessage;